module.exports = {"StatusCode":200,"Payload":"[[]]"}


//////////////////
// WEBPACK FOOTER
// ./src/payloads/aws/lambda/mocks/deleteSubUser.json
// module id = wojr
// module chunks = 0